import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sending-configuration-overrides-using-rules"
    }}>{`Sending configuration overrides using Rules`}</h1>
    <p>{`By default, all `}<strong parentName="p">{`Edge Experience events`}</strong>{` are sent to the datastream specified in the `}<strong parentName="p">{`Adobe Experience Platform Edge Network`}</strong>{` extension configuration settings. This tutorial offers examples on how to customize this configuration on a per-event basis`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <p>{`Before continuing with this tutorial, please ensure that the Edge extension version meets the minimum requirements:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../index.md"
        }}>{`Edge`}</a>{` extension version >= `}<strong parentName="li">{`2.4.0`}</strong>{` (Android) and >= `}<strong parentName="li">{`4.3.0`}</strong>{` (iOS).`}</li>
    </ul>
    <p>{`Additionally, please complete the following tutorials:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../../home/getting-started/configure-datastreams.md"
        }}>{`Configure datastreams`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/experience-platform/datastreams/configure.html?lang=en"
        }}>{`Define overrides in your datastream configuration`}</a></li>
    </ul>
    <h2 {...{
      "id": "add-datastream-configuration-overrides-for-lifecycle-edge-events-using-rules"
    }}>{`Add datastream configuration overrides for Lifecycle Edge events using rules`}</h2>
    <p>{`Add a `}<strong parentName="p">{`datastream ID override`}</strong>{` (or `}<strong parentName="p">{`datastream config overrides`}</strong>{`) for `}<inlineCode parentName="p">{`Lifecycle Edge`}</inlineCode>{` events of type `}<strong parentName="p">{`application.launch`}</strong>{` and `}<strong parentName="p">{`application.close`}</strong>{` by following the next steps.`}</p>
    <h3 {...{
      "id": "add-a-new-rule-for-your-mobile-property"
    }}>{`Add a new rule for your mobile property`}</h3>
    <p>{`Give your rule an easily recognizable name in your list of rules.
In this example, the rule is named "Attach datastream config overrides Data to Lifecycle Edge events".`}</p>
    <h3 {...{
      "id": "configure-lifecycle-edge-events"
    }}>{`Configure Lifecycle Edge Events`}</h3>
    <p>{`Now, add two Lifecycle Edge events: one of type `}<strong parentName="p">{`application.launch`}</strong>{` and other of type `}<strong parentName="p">{`application.close`}</strong>{`.`}</p>
    <h4 {...{
      "id": "configure-lifecycle-edge-event-of-type-applicationlaunch"
    }}>{`Configure Lifecycle Edge event of type application.launch`}</h4>
    <ol>
      <li parentName="ol">{`Under the `}<strong parentName="li">{`Events`}</strong>{` section, select `}<strong parentName="li">{`Add`}</strong>{`.`}</li>
      <li parentName="ol">{`From the `}<strong parentName="li">{`Extension`}</strong>{` dropdown list, select `}<strong parentName="li">{`Adobe Experience Platform Edge Network`}</strong>{`.`}</li>
      <li parentName="ol">{`From the `}<strong parentName="li">{`Event Type`}</strong>{` dropdown list, select `}<strong parentName="li">{`AEP Request Event`}</strong>{`.`}</li>
      <li parentName="ol">{`On the right pane, click the plus button `}<strong parentName="li">{`Add XDM Event Type`}</strong>{` and set the condition to `}<strong parentName="li">{`equals`}</strong>{` with value `}<strong parentName="li">{`application.launch`}</strong>{`.`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Keep Changes`}</strong>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/723442fd0886fa583c209ff8e753786f/5530d/if-event-application-launch.webp 320w", "/client-sdks/static/723442fd0886fa583c209ff8e753786f/0c8fb/if-event-application-launch.webp 640w", "/client-sdks/static/723442fd0886fa583c209ff8e753786f/94b1e/if-event-application-launch.webp 1280w", "/client-sdks/static/723442fd0886fa583c209ff8e753786f/cdc4c/if-event-application-launch.webp 1649w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/723442fd0886fa583c209ff8e753786f/dd4a7/if-event-application-launch.png 320w", "/client-sdks/static/723442fd0886fa583c209ff8e753786f/0f09e/if-event-application-launch.png 640w", "/client-sdks/static/723442fd0886fa583c209ff8e753786f/bbbf7/if-event-application-launch.png 1280w", "/client-sdks/static/723442fd0886fa583c209ff8e753786f/e315f/if-event-application-launch.png 1649w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/static/723442fd0886fa583c209ff8e753786f/bbbf7/if-event-application-launch.png",
            "alt": "Sample rule configuration application.launch event",
            "title": "Sample rule configuration application.launch event",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "configure-lifecycle-edge-event-of-type-applicationclose"
    }}>{`Configure Lifecycle Edge event of type application.close`}</h4>
    <ol>
      <li parentName="ol">{`Under the `}<strong parentName="li">{`Events`}</strong>{` section, select `}<strong parentName="li">{`Add`}</strong>{`.`}</li>
      <li parentName="ol">{`From the `}<strong parentName="li">{`Extension`}</strong>{` dropdown list, select `}<strong parentName="li">{`Adobe Experience Platform Edge Network`}</strong>{`.`}</li>
      <li parentName="ol">{`From the `}<strong parentName="li">{`Event Type`}</strong>{` dropdown list, select `}<strong parentName="li">{`AEP Request Event`}</strong>{`.`}</li>
      <li parentName="ol">{`On the right pane, click the plus button `}<strong parentName="li">{`Add XDM Event Type`}</strong>{` and set the condition to `}<strong parentName="li">{`equals`}</strong>{` with value `}<strong parentName="li">{`application.close`}</strong>{`.`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Keep Changes`}</strong>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "32.49999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/564d443517484e57efa586d7e860163f/5530d/if-event-application-close.webp 320w", "/client-sdks/static/564d443517484e57efa586d7e860163f/0c8fb/if-event-application-close.webp 640w", "/client-sdks/static/564d443517484e57efa586d7e860163f/94b1e/if-event-application-close.webp 1280w", "/client-sdks/static/564d443517484e57efa586d7e860163f/e7fea/if-event-application-close.webp 1648w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/564d443517484e57efa586d7e860163f/dd4a7/if-event-application-close.png 320w", "/client-sdks/static/564d443517484e57efa586d7e860163f/0f09e/if-event-application-close.png 640w", "/client-sdks/static/564d443517484e57efa586d7e860163f/bbbf7/if-event-application-close.png 1280w", "/client-sdks/static/564d443517484e57efa586d7e860163f/55862/if-event-application-close.png 1648w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/static/564d443517484e57efa586d7e860163f/bbbf7/if-event-application-close.png",
            "alt": "Sample rule configuration application.close event",
            "title": "Sample rule configuration application.close event",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Save the event configuration and return to the Rule Editor UI.`}</p>
    <h3 {...{
      "id": "configure-attach-data-action"
    }}>{`Configure Attach Data Action`}</h3>
    <p>{`Based on the use case, you can `}<strong parentName="p">{`either`}</strong>{` attach payload for the `}<strong parentName="p">{`datastream ID override`}</strong>{` or for the `}<strong parentName="p">{`datastream config overrides`}</strong>{`:`}</p>
    <h4 {...{
      "id": "configure-the-action-to-attach-datastream-id-override-payload"
    }}>{`Configure the action to attach datastream ID override payload`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Under the `}<strong parentName="p">{`Actions`}</strong>{` section, select `}<strong parentName="p">{`Add`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the `}<strong parentName="p">{`Extension`}</strong>{` dropdown list, select `}<strong parentName="p">{`Mobile Core`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the `}<strong parentName="p">{`Action Type`}</strong>{` dropdown list, select `}<strong parentName="p">{`Attach Data`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the right pane, in the `}<strong parentName="p">{`JSON Payload`}</strong>{` field, type the config overrides data that will be added to this event.`}</p>
        <p parentName="li"><strong parentName="p">{`Sample Payload for datastream ID override:`}</strong></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-json"
          }}>{`{
    "config": {
        "datastreamIdOverride": "SampleDatastreamID"
    }
}
`}</code></pre>
        <p parentName="li"><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1280px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block",
                "transition": "opacity 0.5s 0.5s",
                "pointerEvents": "none"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/client-sdks/static/c1878797eccc71373f0821db9f794e24/5530d/datastream-id-override-payload.webp 320w", "/client-sdks/static/c1878797eccc71373f0821db9f794e24/0c8fb/datastream-id-override-payload.webp 640w", "/client-sdks/static/c1878797eccc71373f0821db9f794e24/94b1e/datastream-id-override-payload.webp 1280w", "/client-sdks/static/c1878797eccc71373f0821db9f794e24/e7fea/datastream-id-override-payload.webp 1648w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/client-sdks/static/c1878797eccc71373f0821db9f794e24/dd4a7/datastream-id-override-payload.png 320w", "/client-sdks/static/c1878797eccc71373f0821db9f794e24/0f09e/datastream-id-override-payload.png 640w", "/client-sdks/static/c1878797eccc71373f0821db9f794e24/bbbf7/datastream-id-override-payload.png 1280w", "/client-sdks/static/c1878797eccc71373f0821db9f794e24/55862/datastream-id-override-payload.png 1648w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/client-sdks/static/c1878797eccc71373f0821db9f794e24/bbbf7/datastream-id-override-payload.png",
                "alt": "Action configuration - Datastream ID override payload ",
                "title": "Action configuration - Datastream ID override payload ",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "opacity": "0",
                  "transition": "opacity 0.5s",
                  "color": "inherit",
                  "boxShadow": "inset 0px 0px 0px 400px none",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<strong parentName="p">{`Keep Changes`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Return to the Rule Editor UI.`}</p>
      </li>
    </ol>
    <h4 {...{
      "id": "configure-the-action-to-attach-datastream-configuration-override-payload"
    }}>{`Configure the action to attach datastream configuration override payload`}</h4>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`In order to use this feature, configuration overrides in this case event dataset override must be preset in the datastream configuration. Learn more about this configuration in the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/datastreams/overrides.html?lang=en#event-dataset-overrides"
      }}>{`configuring datastream overrides guide`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Under the `}<strong parentName="p">{`Actions`}</strong>{` section, select `}<strong parentName="p">{`Add`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the `}<strong parentName="p">{`Extension`}</strong>{` dropdown list, select `}<strong parentName="p">{`Mobile Core`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the `}<strong parentName="p">{`Action Type`}</strong>{` dropdown list, select `}<strong parentName="p">{`Attach Data`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the right pane, in the `}<strong parentName="p">{`JSON Payload`}</strong>{` field, type the config overrides data that will be added to this event.`}</p>
        <p parentName="li">{` `}<strong parentName="p">{`Sample Payload for datastream config overrides:`}</strong></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-json"
          }}>{`{
    "config": {
        "datastreamConfigOverride": {
            "com_adobe_experience_platform": {
                "datasets": {
                    "event": {
                        "datasetId": "SampleEventDatasetIdOverride"
                    }
                }
            }
        }
    }
}
`}</code></pre>
        <p parentName="li"><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1280px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.125%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block",
                "transition": "opacity 0.5s 0.5s",
                "pointerEvents": "none"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/5530d/datastream-config-override-payload.webp 320w", "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/0c8fb/datastream-config-override-payload.webp 640w", "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/94b1e/datastream-config-override-payload.webp 1280w", "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/cdc4c/datastream-config-override-payload.webp 1649w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/dd4a7/datastream-config-override-payload.png 320w", "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/0f09e/datastream-config-override-payload.png 640w", "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/bbbf7/datastream-config-override-payload.png 1280w", "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/e315f/datastream-config-override-payload.png 1649w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/client-sdks/static/e1a219cb9a4c4cd1627338d99b14b010/bbbf7/datastream-config-override-payload.png",
                "alt": "Action configuration - Datastream ID override payload ",
                "title": "Action configuration - Datastream ID override payload ",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "opacity": "0",
                  "transition": "opacity 0.5s",
                  "color": "inherit",
                  "boxShadow": "inset 0px 0px 0px 400px none",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<strong parentName="p">{`Keep Changes`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Return to the Rule Editor UI.`}</p>
      </li>
    </ol>
    <h3 {...{
      "id": "save-the-rule-and-publish-the-updated-library"
    }}>{`Save the rule and publish the updated library`}</h3>
    <p>{`The final rule should appear as follows:
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "43.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/f38fd32327971c1c1a0594c80a231382/5530d/final-rule-configoverrides.webp 320w", "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/0c8fb/final-rule-configoverrides.webp 640w", "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/94b1e/final-rule-configoverrides.webp 1280w", "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/e7fea/final-rule-configoverrides.webp 1648w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/f38fd32327971c1c1a0594c80a231382/dd4a7/final-rule-configoverrides.png 320w", "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/0f09e/final-rule-configoverrides.png 640w", "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/bbbf7/final-rule-configoverrides.png 1280w", "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/55862/final-rule-configoverrides.png 1648w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/static/f38fd32327971c1c1a0594c80a231382/bbbf7/final-rule-configoverrides.png",
            "alt": "File Rules configuration",
            "title": "File Rules configuration",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Save`}</strong>{` this Rule, `}<strong parentName="p">{`publish`}</strong>{` the new Tags library with all the changes, and your rule will be set and ready. Now, Lifecycle Edge events of type `}<strong parentName="p">{`application.launch`}</strong>{` and `}<strong parentName="p">{`application.close`}</strong>{` will be sent with the overridden datastream ID or datastream config overrides payload.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      